import {
  Truck, Boxes, Tag, LineChart, ShoppingBag,
  Package, Database, Headphones, Megaphone, AlertCircle, UserCircle2,
  Briefcase,
} from 'lucide-react';

/**
 * LampTwist app catalogue · slug is the stable key persisted on the
 * employee (Employee.favorite_apps). Names with `name: null` come from
 * translations (key `splash.app.<slug>.name`). The HR portal is just
 * another app in the `internal` group · `internal=true` routes via
 * react-router `to`, not an external `href`.
 */
export const APP_CATALOGUE = [
  { slug: 'perfy',  name: 'Perfy',  href: 'https://perfy.lamptwist.be',  icon: LineChart,   group: 'commerce', dot: '#10B981', tint: 'rgba(16, 185, 129, 0.08)' },
  { slug: 'quoty',  name: 'Quoty',  href: 'https://quoty.lamptwist.be',  icon: Tag,         group: 'commerce', dot: '#F97316', tint: 'rgba(249, 115, 22, 0.09)' },
  { slug: 'mosy',   name: 'Mosy',   href: 'https://mosy.lamptwist.be',   icon: Megaphone,   group: 'commerce', dot: '#EC4899', tint: 'rgba(236, 72, 153, 0.08)' },

  { slug: 'pim',    name: 'PIM',    href: 'https://pim.lamptwist.be',    icon: Database,    group: 'products', dot: '#6366F1', tint: 'rgba(99, 102, 241, 0.08)' },
  { slug: 'dory',   name: 'Dory',   href: 'https://dory.lamptwist.be',   icon: Package,     group: 'products', dot: '#0EA5E9', tint: 'rgba(14, 165, 233, 0.08)' },

  { slug: 'purchy', name: 'Purchy', href: 'https://purchy.lamptwist.be', icon: ShoppingBag, group: 'supply',   dot: '#D97706', tint: 'rgba(217, 119, 6, 0.09)' },
  { slug: 'spacy',  name: 'Spacy',  href: 'https://spacy.lamptwist.be',  icon: Boxes,       group: 'supply',   dot: '#8B5CF6', tint: 'rgba(139, 92, 246, 0.08)' },
  { slug: 'shippy', name: 'Shippy', href: 'https://shippy.lamptwist.be', icon: Truck,       group: 'supply',   dot: '#3B82F6', tint: 'rgba(59, 130, 246, 0.08)' },

  { slug: 'scotty', name: 'Scotty', href: 'https://scotty.lamptwist.be', icon: Headphones,  group: 'care',     dot: '#14B8A6', tint: 'rgba(20, 184, 166, 0.08)' },
  { slug: 'claimy', name: 'Claimy', href: 'https://claimy.lamptwist.be', icon: AlertCircle, group: 'care',     dot: '#EF4444', tint: 'rgba(239, 68, 68, 0.08)' },

  { slug: 'odoo',   name: 'Odoo',   href: 'https://lamptwist.odoo.com/', icon: Briefcase,   group: 'internal', dot: '#714B67', tint: 'rgba(113, 75, 103, 0.08)' },
  { slug: 'hr',     name: null,     to: '/',                             icon: UserCircle2, group: 'internal', dot: '#2B4138', tint: 'rgba(43, 65, 56, 0.10)', internal: true },
];

export const GROUP_ORDER = ['products', 'purchase', 'supply', 'commerce', 'pricing', 'care', 'accounting', 'internal'];

/* Shared LampTwist brand palette · used by chrome + sidebars.
 * `yellow` is the saturated brand mark (matches the lightbulb halo
 * in the logo); `yellowLight` is the soft background tint.
 * `greenSoft` is a green-tinted background that pairs with greenDeep
 * for subtle "branded" surfaces without going dark. */
export const LT = {
  greenDeep:   '#2B4138',
  greenMid:    '#7C9890',
  greenSoft:   '#E6ECE7',
  green30:     '#BFC6C3',
  green50:     '#95A09B',
  beigeWarm:   '#EDECE5',
  beigeLight:  '#FBFBFA',
  yellow:      '#FFBD09',  // brand lamp yellow · accent only, never a button
  yellowLight: '#FFF6D9',
  cta:         '#469E7A',  // brand action green · save, send, add
  ctaHover:    '#3A8767',
};
